module.exports = __webpack_public_path__ + "img/IMG_0691.4a1a49cf.jpg";